import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Route, Redirect, Link } from "react-router-dom"
import { canAccessCpPage } from "helpers/cpAccessPolicy"
import { connect } from "react-redux"

import * as actions from "../../pages/Authentication/actions"
import {Spinner} from "reactstrap";
import SessionUnavailable from "./SessionUnavailable"

const allowedRoles = ["admin", "superAdmin"]

const AuthMiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  getClientDetails,
  getSession,
  getSettings,
  userDetails = null,
  settings = null,
  sessionUnavailable = null,
  sessionPending = false,
  ...rest
}) => {
  const initilized = userDetails === null
  const settingsInitilized = settings === null
  
  // Fetch User Details
  useEffect(() => {
    const onMount = async () => {
      if (isAuthProtected && initilized) {
        getSession()
      }
    }
    onMount()
  }, [isAuthProtected, getSession, initilized])
  
  // Fetch settings
  useEffect(() => {
    const onMount = async () => {
      if (settingsInitilized) {
        getSettings()
      }
    }
    onMount()
  }, [settingsInitilized, getSettings])

  return (
    <Route
      {...rest}
      render={props => {
        if (
          userDetails !== null &&
          isAuthProtected &&
          !(userDetails && allowedRoles.includes(userDetails.role))
        ) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          )
        }

        if (userDetails === null && isAuthProtected && sessionUnavailable) {
          return <SessionUnavailable reason={sessionUnavailable} retrying={sessionPending} onRetry={getSession} />
        }

        if (userDetails === null && isAuthProtected) {
          return <>
            <div className="align-items-center d-flex justify-content-center min-vh-100">
              <Spinner className="mt-5 mb-5" color="primary"/>
            </div>
          </>
        }

        if (isAuthProtected && !canAccessCpPage(userDetails, props.location.pathname)) {
          return <Layout><div className="page-content"><div className="container-fluid">
            <div className="card"><div className="card-body" role="alert">
              <h4>Super admin access required</h4>
              <p>Only Super admins can access this section.</p>
              <Link className="btn btn-primary" to="/dashboard">Back to dashboard</Link>
            </div></div>
          </div></div></Layout>
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        )
      }}
    />
  )
}

AuthMiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

const mapStateToProps = ({ session: { userDetails, settings, sessionUnavailable, sessionPending } = {} }) => ({ userDetails, settings, sessionUnavailable, sessionPending })

export default connect(mapStateToProps, {
  getSession: actions.getSession,
  getSettings: actions.getSettings,
})(AuthMiddleware)
